import React from 'react';
import { Link } from 'react-router-dom';

export default function IconBoxStyle4({ title, subTitle, iconUrl, href }) {
  return (
    <div className="cs_iconbox cs_style_4" style={{ backgroundColor: '#fff', boxShadow: '4px 4px 16px rgba(0, 0, 0, 0.2)', height: '300px' }}>
      <div className="cs_iconbox_icon cs_accent_bg rounded-circle cs_center">
        <img src={iconUrl} alt="Icon" />
      </div>
      <h2 className="cs_iconbox_title cs_fs_32" style={{ color: '#0e6ebe' }}>{title}</h2>
      <p className="cs_iconbox_subtitle m-0" style={{ color: '#000' }}>{subTitle}</p>
    </div>
  );
}
